module.exports = __webpack_public_path__ + "static/media/pie-chart5.08aac68a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/icons/pie-chart5.svg
// module id = 3334
// module chunks = 7